/* Sticky add-to-cart bar, mobile PDP (§4.1).
   Appears once the buy box's action area has scrolled above the viewport;
   hides again when scrolling back up past it. Mirrors the size selection
   both ways with the main form and delegates the actual add to
   product-form so there is exactly one add path. */

class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-sticky-select]');
    this.priceEl = this.querySelector('[data-sticky-price]');
    this.submit = this.querySelector('[data-sticky-submit]');
    this.productForm = document.querySelector('product-form');
    const watched = document.querySelector(this.dataset.watch);
    if (!watched || !this.productForm) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const above = entry.boundingClientRect.bottom < 0;
        this.hidden = entry.isIntersecting || !above;
        this.classList.toggle('is-visible', !this.hidden);
      },
      { threshold: 0 }
    );
    observer.observe(watched);

    if (this.select) {
      this.select.addEventListener('change', () => {
        const variant = this.productForm.variants.find((v) => String(v.id) === this.select.value);
        if (!variant) return;
        // Reflect into the main form's radios; its change handler does the rest.
        variant.options.forEach((value, index) => {
          const radio = this.productForm.querySelectorAll('.pdp__option')[index]
            ?.querySelector(`input[value="${CSS.escape(value)}"]`);
          if (radio && !radio.checked) {
            radio.checked = true;
          }
        });
        this.productForm.onOptionChange();
      });
    }

    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail.variant;
      if (!variant) return;
      if (this.select && this.select.value !== String(variant.id)) this.select.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = window.Dotto.formatMoney(variant.price);
      const soldOut = !variant.available;
      this.submit.toggleAttribute('disabled', soldOut);
      this.submit.textContent = soldOut
        ? window.Dotto.strings.soldOut
        : this.productForm.isPreorder
          ? window.Dotto.strings.preorder
          : window.Dotto.strings.addToBag;
    });

    this.submit.addEventListener('click', () => {
      this.productForm.form.requestSubmit();
    });
  }
}

if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
